module.exports = __webpack_public_path__ + "static/media/por7o.9168f9e0.jpg";